import {Component, Injectable} from '@angular/core';
import {VumarkToolViewModel} from '../../viewmodel/VuMarkToolViewModel';

@Component({
  selector: 'app-vumark-tool',
  templateUrl: 'vumark-tool.component.html',
  styleUrls: ['vumark-tool.component.css'],
})

@Injectable()
export class VumarkToolComponent {
  public viewModel = new VumarkToolViewModel();

  private readonly campusBitPattern = 0x00C00000;
  private readonly campusBitOffset = 22;

  private readonly komplexBitPattern = 0x003C0000;
  private readonly komplexBitOffset = 18;

  private readonly gebaeudenummerBitPattern = 0x0003E000;
  private readonly gebaeudenummerBitOffset = 13;

  private readonly stockwerkBitPattern = 0x00001F00;
  private readonly stockwerkBitOffset = 8;

  private readonly raumnummerBitPattern = 0x000000FF;
  private readonly raumnummerBitOffset = 0;

  private pad(s: string, len: number, c: string = '0'): string {
    while (s.length < len) {
      s = c + s;
    }
    return s;
  }

  public calcRight() {
    let zahl = 0;
    zahl = zahl | (this.viewModel.campus << this.campusBitOffset);
    zahl = zahl | (this.viewModel.komplex << this.komplexBitOffset);
    zahl = zahl | (this.viewModel.gebaeudenummer << this.gebaeudenummerBitOffset);
    zahl = zahl | (this.viewModel.stockwerk << this.stockwerkBitOffset);
    zahl = zahl | (this.viewModel.raumnummer << this.raumnummerBitOffset);

    this.viewModel.id = this.pad(zahl.toString(16), 6);
  }

  public calcLeft() {
    const zahl = parseInt(this.viewModel.id, 16);

    this.viewModel.campus = (zahl & this.campusBitPattern) >> this.campusBitOffset;
    this.viewModel.komplex = (zahl & this.komplexBitPattern) >> this.komplexBitOffset;
    this.viewModel.gebaeudenummer = (zahl & this.gebaeudenummerBitPattern) >> this.gebaeudenummerBitOffset;
    this.viewModel.stockwerk = (zahl & this.stockwerkBitPattern) >> this.stockwerkBitOffset;
    this.viewModel.raumnummer = (zahl & this.raumnummerBitPattern) >> this.raumnummerBitOffset;
  }
}
